import {
  IBuildingSchema as DEPRECATED__IBuildingSchema,
  IBusinessShoppingCenterSchema as DEPRECATED__IBusinessShoppingCenterSchema,
} from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { locales } from '../../../../components/commercial/locales';
import { IOption, Option } from '../../../../models/Option';
import { IBuildingSchema } from '../../../../repositories/offer-card/entities/building/BuildingSchema';
import { IBusinessShoppingCenterSchema } from '../../../../repositories/offer-card/entities/business_shopping_center/BusinessShoppingCenterSchema';
import { getShoppingCenterScaleType } from '../../../../utils/building';
import { IOptionFacade } from '../../IOptionFacade';

export class ShoppingCenterScaleTypeOptionFacade implements IOptionFacade<string, string> {
  protected readonly building: IBuildingSchema | null;
  protected readonly businessShoppingCenter: IBusinessShoppingCenterSchema | null;

  public constructor(building: IBuildingSchema | null, businessShoppingCenter: IBusinessShoppingCenterSchema | null) {
    this.building = building;
    this.businessShoppingCenter = businessShoppingCenter;
  }

  public getOption(): IOption<string, string> | null {
    const value = this.value;

    if (!value) {
      return null;
    }

    return new Option(this.label, value, this.key);
  }

  protected get value(): string | null {
    const shoppingCenterScaleType = getShoppingCenterScaleType(
      this.building as DEPRECATED__IBuildingSchema | null,
      this.businessShoppingCenter as DEPRECATED__IBusinessShoppingCenterSchema | null,
    );

    if (!shoppingCenterScaleType) {
      return null;
    }

    return locales.shoppingCenterScaleType[shoppingCenterScaleType];
  }

  protected get label(): string {
    return 'Масштаб торгового комплекса';
  }

  protected get key(): string {
    return 'shoppingCenterScaleType';
  }
}
